import React, { Component } from 'react'

import Carrousel from './main-components/carrousel.js'
import Triangles from './main-components/triangles.js'
import Contacto from './contacto.js'
import Info from './info.js'

export default class Sections extends Component {
	
	constructor(props) {
		super(props);
		
		var section = this.props.location.pathname.replace (/\//g, "") === '' 
			? 'home' 
			: this.props.location.pathname.replace (/\//g, "");
			
		this.state = {
			section: section,			
			info: Info[section]
		};
	}
	
	componentDidMount(){
		document.body.style.backgroundImage = 
		`url('../../img/${this.state.section}/BACKGROUND.jpg')`;
	}
	
	render() {
		console.log(this.state.section);
		return (
			<div id = "content">
				{ 	
					this.state.section === 'contacto'
						? <Contacto
							section={this.state.section}
							info={this.state.info}
						/>
						: <Carrousel
							section={this.state.section}
							info={this.state.info}
						/>
				}
				<Triangles 
					section={this.state.section}
					info={this.state.info}
				/>
			</div>
		)
	}
}

/*
<Carrousel
	section={this.state.section}
	info={this.state.info}
/>
<Triangles 
	section={this.state.section}
	info={this.state.info}
/>
*/


// WEBPACK FOOTER //
// ./src/components/main.js